export const LOCALSTORAGE_PREFIX = 'hatsuly'

export const saveStateToLocalStorage = (key: string, value: unknown) => {
  const serializedValue = JSON.stringify(value)
  localStorage.setItem(`${LOCALSTORAGE_PREFIX}_${key}`, serializedValue)
}

export const loadStateFromLocalStorage = <T>(key: string, defaultValue: T): T => {
  const item = localStorage.getItem(`${LOCALSTORAGE_PREFIX}_${key}`)
  if (item === null) {
    return defaultValue
  }
  return JSON.parse(item) as T
}

export const deleteStateFromLocalStorage = (key: string) => {
  localStorage.removeItem(`${LOCALSTORAGE_PREFIX}_${key}`)
}

export class LocalStorageManager<T> {
  private key: string

  private defaultValue: T

  constructor(key: string, defaultValue: T) {
    this.key = `${LOCALSTORAGE_PREFIX}::${key}`
    this.defaultValue = defaultValue
  }

  save(value: T) {
    saveStateToLocalStorage(this.key, value)
  }

  load(): T {
    try {
      return loadStateFromLocalStorage<T>(this.key, this.defaultValue)
    } catch {
      return this.defaultValue
    }
  }

  clear() {
    deleteStateFromLocalStorage(this.key)
  }
}
